import { IoElementsList } from "@/components/Account/IoElementsList";
import { Button } from "@/components/ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { INTELLIGENCE_DEV_PRICE_MODEL, INTELLIGENCE_PRICE_MODEL } from "@/constants/user";
import { cn } from "@/lib/utils";
import { useMainStore } from "@/store/main";
import { useUserStore } from "@/store/user";
import { useState } from "react";
import { ToolLightLogo } from "@/components/Common/ToolLogo/ToolLightLogo";
import env from "@/env";
import { getIoElementHref } from "@/utils/tool";

export const MainLogo = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const tool = useMainStore((state) => state.tool);
  const theme = useUserStore((state) => state.theme);
  const currentSubscription = useUserStore((state) => state.currentSubscription);
  const isIntelligencePremiumSubscriptionActive =
    currentSubscription?.subscription_details?.pricing_model === INTELLIGENCE_PRICE_MODEL;
  const isIntelligenceDeveloperSubscriptionActive =
    currentSubscription?.subscription_details?.pricing_model === INTELLIGENCE_DEV_PRICE_MODEL;
  const showProBadge = isLoggedIn && tool.value === "ai" && isIntelligencePremiumSubscriptionActive;
  const showDeveloperBadge =
    isLoggedIn && tool.value === "ai" && isIntelligenceDeveloperSubscriptionActive;
    
  return (
    <>
      <HoverCard data-testid={"MainLogo_popover"} open={isPopoverOpen} openDelay={300}>
        <HoverCardTrigger
          onMouseEnter={() => setIsPopoverOpen(true)}
          onMouseLeave={() => setIsPopoverOpen(false)}
          onClick={() => setIsPopoverOpen(!isPopoverOpen)}
          className="mr-auto"
        >
          <Button
            size="sm"
            variant="outline"
            className={`h-[32px] gap-2 rounded-[8px] bg-gray-dark-1400 duration-300 hover:border-gray-dark-1200 hover:bg-background ${isPopoverOpen ? "border-gray-dark-1200" : "border-gray-dark-200"}`}
          >
            {tool && (
              <>
                <ToolLightLogo tool={tool} />
                {(showProBadge || showDeveloperBadge) && (
                  <div
                    className={cn(
                      "relative h-[21px] w-[42px] flex-shrink-0 max-md:hidden",
                      showDeveloperBadge && "h-[24px] w-[75px]"
                    )}
                  >
                    {showProBadge && theme === "dark" && (
                      <div className="absolute left-0 top-0 h-[21px] w-[42px] rounded-full border-r-[1.25px] border-[#87D3FF] backdrop-blur-[0.25px]"></div>
                    )}
                    {showDeveloperBadge && theme === "dark" && (
                      <div className="absolute left-0 top-0 h-[24px] w-[75px] rounded-full border-r-[1.25px] border-[#98FF9B] backdrop-blur-[0.25px]"></div>
                    )}
                    <img
                      src={
                        showProBadge
                          ? theme === "dark"
                            ? "/assets/images/pro-badge.svg"
                            : "/assets/images/pro-badge-light.svg"
                          : theme === "dark"
                            ? "/assets/images/developer-badge.svg"
                            : "/assets/images/developer-badge-light.svg"
                      }
                      className={cn(
                        "h-[21px] w-[42px] rounded-full object-none",
                        showDeveloperBadge && "h-[24px] w-[75px]"
                      )}
                      alt={showProBadge ? "pro-plan" : "developer-plan"}
                    />
                  </div>
                )}
                <img
                  src={
                    theme === "dark"
                      ? "/assets/images/chevron-up-down.svg"
                      : "/assets/images/chevron-up-down-light.svg"
                  }
                  className="h-[12px] w-auto flex-shrink-0"
                  alt="chevron"
                />
              </>
            )}
          </Button>
          <HoverCardContent className="mt-[-8px] border-none bg-transparent p-0 pt-4" align="start">
            <div
              data-testid={"MainLogo_popoverPanel"}
              className={cn(
                `_md:w-[650px] grid w-[calc(100vw-42px)] gap-2 rounded-lg border border-gray-dark-1200 bg-white p-2 dark:bg-black md:w-[345px] md:p-3`,
                env.EXPLORER_COMBINED ? "lg:grid-cols-1" : "grid-cols-2 lg:grid-cols-2"
              )}
            >
              <IoElementsList
                resolveHref={(item) => getIoElementHref(item.value, item.href ?? "")}
                onClick={() => setIsPopoverOpen(false)}
              />
            </div>
          </HoverCardContent>
        </HoverCardTrigger>
      </HoverCard>
    </>
  );
};
